import React, { useEffect, useState, useLayoutEffect } from "react";
import { Button, Container } from "@mui/material";
import styles from "./layout.module.css";
import NavBar from "./navbar/Navbar";
import BottomNavBar from "./bottomNavBar/BottomNavBar";
import { Outlet } from "react-router-dom";

// context for navbar
import { NavBarProvider } from "../context/NavBarContext";
import { useMusic } from "../context/MusicContext";
import { useAudio } from "../context/AudioContext";
import { useLocation } from "react-router-dom";
// music popup
import MusicPopUp from "../components/musicPopUp/MusicPopUp";
// music Wrapper
import MusicWrapper from "../components/wrapper/MusicWrapper";
import AudioWrapper from "../components/wrapper/AudioWrapper";

import { useNavigate } from "react-router";
import InitialScreen from "../components/initialScreens/InitialScreen";
import ScrollToTop from "../components/ScrollToTop";

const Index = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const musicContext = useMusic();
  const audioContext = useAudio();
  const path = location.pathname;

  const [showInitialScreen, setShowInitialScreen] = useState(true);

  useEffect(() => {
    if (path.includes("audio")) {
      musicContext.pauseAudio();
      musicContext.setIsPopUpRemove(true);
    } else {
      if (path.includes("music/detail/songs")) {
        musicContext.setIsPopUpRemove(true);
      } else {
        musicContext.setIsPopUpRemove(false);
      }
    }
  
    if (path.includes("audio")) {
      audioContext.setIsPopUpRemove(false);
    } else {
      audioContext.pauseAudio();
      audioContext.setIsPopUpRemove(true);
    }
  
  }, [path]);

  useEffect(() => {
    const show_tcpage = JSON.parse(localStorage.getItem("show_tcpage"));
    if (show_tcpage == "1") {
      setShowInitialScreen(true);
    } else {
      setShowInitialScreen(false);
      // navigate("/");
    }
  }, [])
  

  const handleInitialScreenOk = () => {
    localStorage.setItem("show_tcpage", "0");
    setShowInitialScreen(false);
  };

  return (
    <div className="relative">
      <ScrollToTop />
      {showInitialScreen ? (
        // Render the initial screen component here
        <InitialScreen onOkClick={handleInitialScreenOk} />
      ) : (
        <NavBarProvider>
          <NavBar />
          <Container
            maxWidth="xl"
            className={`relative pt-16 ${styles.noScrollBar}`}
          >
            <main style={{ marginBottom: "8rem" }}>
              <Outlet />
            </main>
          </Container>

          <BottomNavBar />
        </NavBarProvider>
      )}
      {musicContext.data ? <MusicWrapper /> : ""}
      {audioContext ? <AudioWrapper /> : ""}
    </div>
  );
};

export default Index;
